import React from 'react';

import { getConfigurationAssetUrl } from '@services/api/constants';
import { useConfigurationStore } from '@store/use-configuration-store';

interface ImageProps {
  id: string | undefined;
  alt?: string;
  style?: React.CSSProperties;
  className?: string;
}

function Image({ id, alt = '', style, className }: ImageProps) {
  const { friendly_url, module } = useConfigurationStore();
  if (!id) return null;
  const src = getConfigurationAssetUrl(friendly_url, module, 'image', id);
  return <img src={src} alt={alt} style={style} className={className} />;
}

export default Image;
